import { defineComponent as _defineComponent } from 'vue'
import UserDetails from '@/features/user-profile/components/sections/UserDetails.vue';
import UserTextRecommendationPreview from '@/features/user-profile/components/sections/UserTextRecommendationPreview.vue';
import UserArticles from '@/features/user-profile/components/sections/UserArticles.vue';
import UserTitles from '@/features/user-profile/components/sections/UserTitles.vue';
import UserTextRecommendations from '@/features/user-profile/components/views/UserTextRecommendations.vue';
import UserProfileEdit from '@/features/user-profile/components/views/UserProfileEdit.vue';
import UserTitlesPreview from '@/features/user-profile/components/sections/UserTitlesPreview.vue';

import { useUserProfile } from '@/features/user-profile/composables/useUserProfile';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfile',
  setup(__props) {

const { isLoading, currentView, personContentId } = useUserProfile();

return { __sfc: true,isLoading, currentView, personContentId, UserDetails, UserTextRecommendationPreview, UserArticles, UserTitles, UserTextRecommendations, UserProfileEdit, UserTitlesPreview }
}

})